/**
 * @deprecated Import from '@/components/molecules' or '@/molecules' instead.
 * This file is kept for backwards compatibility during migration.
 */

export { Quantity, QuantitySelector } from '@/components/molecules/interactive';
